import { render, staticRenderFns } from "./UiGoogle.vue?vue&type=template&id=2f173eec"
import script from "./UiGoogle.vue?vue&type=script&lang=js"
export * from "./UiGoogle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports